export { default } from "./InputSelect";
